export default __webpack_public_path__ + "static/media/char_select_fox.3b9b8bfc.png";